import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import {
  apiDocsConfigRef,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import * as React from 'react';
import { ApiEntity } from '@backstage/catalog-model';
import { GrpcDocsWidget } from './components/grpc/GrpcDocsWidget';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: apiDocsConfigRef,
    deps: {},
    factory: () => {
      const definitionWidgets = defaultDefinitionWidgets();

      definitionWidgets.push({
        type: 'grpc-docs',
        title: 'gRPC',
        component: (definition: string) =>
          React.createElement(GrpcDocsWidget, { definition }),
      });

      return {
        getApiDefinitionWidget: (apiEntity: ApiEntity) =>
          definitionWidgets.find(d => d.type === apiEntity.spec.type),
      };
    },
  }),
];
